import React from 'react';
import { useQuery } from '@apollo/client';
import OneColumnPage from '../../app/layout/OneColumnPage';
import PageLayout from '../../app/layout/PageLayout';
import GroupSquarishCard from '../../components/GroupSquarishCard';
import SquarishCardGrid from '../../components/SquarishCardGrid';
import { gql } from '../../graphql/generated/gql';
import PageMeta from '../../utils/PageMeta';
import useErrorRedirectEffect from '../../utils/error/useErrorRedirectEffect';
import useSlug from '../../utils/router/useSlug';
import UserPostsList from './UserPostsList';
import UserProfileHeader from './UserProfileHeader';
import * as styles from './UserProfileView.module.scss';

const USER_PROFILE_QUERY = gql(/** @complexity 15 */ `
  query UserProfileUser($id: ID!) {
    user(id: $id) {
      id
      name
      membershipGroups {
        id
        ...GroupSquarishCard_group
      }
      ...UserProfileHeader_user
      ...UserPostsList_user
    }
  }
`);

const UserProfileView = () => {
  const [userId] = useSlug('userSlug');

  const { data, error } = useQuery(USER_PROFILE_QUERY, {
    variables: { id: userId },
  });

  useErrorRedirectEffect({ noun: 'user', error });

  const user = data?.user;
  const membershipGroups = user ? user.membershipGroups : null;

  if (!user) return null;

  return (
    <PageLayout.Content noPaddingX noPaddingY>
      <PageMeta
        title={`${user.name} - Slab`}
        desktopTabIcon={user.avatar?.thumb}
      />
      <OneColumnPage>
        <UserProfileHeader user={user} />
        {!!membershipGroups?.length && (
          <>
            <h3>Groups</h3>
            <div className={styles.userGroups}>
              <SquarishCardGrid>
                {membershipGroups.map((group) => (
                  <SquarishCardGrid.Item key={group.id}>
                    <GroupSquarishCard group={group} link />
                  </SquarishCardGrid.Item>
                ))}
              </SquarishCardGrid>
            </div>
          </>
        )}
        <UserPostsList user={user} />
      </OneColumnPage>
    </PageLayout.Content>
  );
};

export default UserProfileView;
